/**
 * Bundled translation resources. Italian is the source language, the typed
 * `t()` keys come from the `it` files, so a wrong key is a `tsc` error.
 *
 * To add a namespace: create `it/<ns>.json` + `en/<ns>.json`, import both
 * here, add them to `it` and `en`. Everything else (typing, i18n Ally) follows.
 */

// --- New website namespaces ---
import enAbout from "./en/about.json";
import enCapital from "./en/capital.json";
// --- EN ---
import enCommon from "./en/common.json";
import enCompaniesHome from "./en/companies-home.json";
import enCompaniesProduct from "./en/companies-product.json";
import enCompanyCommon from "./en/company/common.json";
import enContactForm from "./en/contact-form.json";
import enFaq from "./en/faq.json";
import enHeads from "./en/heads.json";
import enHome from "./en/home.json";
import enProducerCommon from "./en/producer/common.json";
import enProducersHome from "./en/producers-home.json";
import enProducersProduct from "./en/producers-product.json";
import enProducersRoles from "./en/producers-roles.json";
import enPublicProfile from "./en/public-profile.json";
import enBlog from "./en/resources/blog.json";
import enCalculator from "./en/resources/calculator.json";
import enSolutions from "./en/solutions.json";
import itAbout from "./it/about.json";
import itCapital from "./it/capital.json";
import itCommon from "./it/common.json";
import itCompaniesHome from "./it/companies-home.json";
import itCompaniesProduct from "./it/companies-product.json";
import itCompanyCommon from "./it/company/common.json";
// --- Kept-feature namespaces ---
import itContactForm from "./it/contact-form.json";
import itFaq from "./it/faq.json";
import itHeads from "./it/heads.json";
import itHome from "./it/home.json";
import itProducerCommon from "./it/producer/common.json";
import itProducersHome from "./it/producers-home.json";
import itProducersProduct from "./it/producers-product.json";
import itProducersRoles from "./it/producers-roles.json";
import itPublicProfile from "./it/public-profile.json";
import itBlog from "./it/resources/blog.json";
import itCalculator from "./it/resources/calculator.json";
import itSolutions from "./it/solutions.json";

export const defaultNS = "common" as const;

const it = {
  common: itCommon,
  home: itHome,
  "companies-home": itCompaniesHome,
  "companies-product": itCompaniesProduct,
  solutions: itSolutions,
  "producers-home": itProducersHome,
  "producers-product": itProducersProduct,
  "producers-roles": itProducersRoles,
  faq: itFaq,
  about: itAbout,
  capital: itCapital,
  "contact-form": itContactForm,
  "public-profile": itPublicProfile,
  heads: itHeads,
  "resources/calculator": itCalculator,
  "resources/blog": itBlog,
  "company/common": itCompanyCommon,
  "producer/common": itProducerCommon,
};

const en: typeof it = {
  common: enCommon,
  home: enHome,
  "companies-home": enCompaniesHome,
  "companies-product": enCompaniesProduct,
  solutions: enSolutions,
  "producers-home": enProducersHome,
  "producers-product": enProducersProduct,
  "producers-roles": enProducersRoles,
  faq: enFaq,
  about: enAbout,
  capital: enCapital,
  "contact-form": enContactForm,
  "public-profile": enPublicProfile,
  heads: enHeads,
  "resources/calculator": enCalculator,
  "resources/blog": enBlog,
  "company/common": enCompanyCommon,
  "producer/common": enProducerCommon,
};

export const resources = { it, en };
